import { composeIO } from 'react-compose-io'
import { fieldsAcaoIO } from './FieldsAcao.IO'
import { FieldsAcaoView } from './FieldsAcao.View'

export const FieldsAcao = composeIO(FieldsAcaoView, fieldsAcaoIO)
